import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import UI from "../../shared/Components/UI/js";
import {
  Image,
  mem,
  Shadow,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "../../shared/custom-react-native";
import CustomDatatable from "../_components/CustomDatatable";
import EntryPicker from "../_components/EntryPicker";
import InputForm from "../_components/InputForm";
import MainLayout from "../_components/MainLayout";
import "./css.css";

const context = "merchant";

export default class EcommerceViewProduct extends Component {
  constructor(props) {
    super(props);
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "Inventory",
      is_drawer_open: false,
      selected: null,
      current_page: 1,
      data: ["1"],
      context: context,
      item: {
        _id: "",
        merchant: "",
        name: "",
        price: "",
        quantity: 0,
        limit: 0,
        description: "",
        imagePath: "",
        imageFilename: "",
        createdAt: "",
        __v: 0,
        status: "",
      },

      obj: {
        product: {
          _id: "",
          merchant: "",
          name: "",
          price: "",
          quantity: 0,
          limit: 0,
          description: "",
          imagePath: "",
          imageFilename: "",
          createdAt: "",
          __v: 0,
          status: "",
          updatedAt: "",
        },
        user: [],
        productStats: {
          totalFinished: 0,
          totalPurchase: 0,
          inquiries: 0,
        },
      },

      user_obj: [],
      all_data: [],

      transactions: [],
      inquiries: [],

      custom_finished_purchases: 0,
      total_purchase_customers: 0,

      purchasing_customers_id: [],
      total_inquiries: [],
    });
  }
  onCreate = async () => {
    this.load_data();
  };

  // get_inquiries = async () => {
  //   this.show_loading();
  //   UI.webRequest({
  //     method: "get",
  //     url: "admin/inquiries",
  //     params: {},
  //     onFail: async (err) => {},
  //     onSuccess: async (response) => {
  //       const data = UI.extract_data(response);

  //       if (this.state.all_data.length == 0) {
  //         this.setState({
  //           all_data: data.data,
  //         });
  //       }

  //       this.setState(
  //         {
  //           inquiries: data.data,
  //         },
  //         () => {
  //           this.process_product_inquiries();
  //         }
  //       );
  //     },
  //     onFinish: () => {
  //       this.hide_loading();
  //     },
  //   });
  // };

  // process_product_inquiries = async () => {
  //   const { inquiries, id } = this.state;
  //   const total_inquiries = inquiries?.filter((item) => item?.product?._id == id);
  //   this.setState({
  //     total_inquiries,
  //   });
  // };

  get_transactions = async () => {
    this.show_loading();
    UI.webRequest({
      method: "get",
      url: "admin/transactions",
      params: {},
      onFail: async (err) => {},
      onSuccess: async (response) => {
        const data = UI.extract_data(response);
        console.log(data);
        this.setState(
          {
            transactions: data.data,
          },
          () => {
            // this.get_inquiries();
            this.process_product_purchases();
          }
        );
      },
      onFinish: () => {
        //this.hide_loading();
      },
    });
  };

  process_product_purchases = async () => {
    const { transactions, id } = this.state;
    const finished_transactions = transactions.filter((item) => {
      if (item.product?._id === id) {
        return true;
      } else {
        return false;
      }
    });

    let users = [];

    transactions.forEach((item) => {
      if (item.product?._id === id) {
        users.push(item.user?.email);
      }
    });

    const totalPurchaseCustomers = [];

    users.forEach((item) => {
      console.log(item);
      if (
        totalPurchaseCustomers.find(
          (id) => item === id["email"]
          //  item.user?._id === id["_id"]
        )
      ) {
        return;
      }
      totalPurchaseCustomers.push({ email: item });
    });

    this.setState({
      custom_finished_purchases: finished_transactions.length,
      purchasing_customers_id: totalPurchaseCustomers.length,
    });
  };

  load_data = async () => {
    const data = mem.get("view_product_inventory");
    console.log('asdasdasd')

    if (data) {
      const product = JSON.parse(data);

      UI.set_input_value("quantity", product.quantity ?? 0);
      UI.set_select_value("status", product.status ?? "");
      // let a = []
      const description = product.description.split('\r\n')
      // console.log(a.push(description))
      console.log(description)
      // console.log(a)
      this.setState(
        {
          id: product._id,
        },
        () => {
          this.get_product();
        }
      );
      const image = await UI.download_image(product.imagePath, "ecommerce");

      this.setState(
        {
          imagePath: product.imagePath,
          image,
          item: product,
          description_1:description
        },
        () => {
          this.get_transactions();
        }
      );
    }
  };

  get_product = async () => {
    this.show_loading();
    UI.webRequest({
      method: "get",
      url: "admin/products/" + this.state.id,
      params: {},
      isMultiPart: true,
      onFail: async (err) => {
        // const data = err.data;
      },
      onSuccess: async (response) => {
        const data = UI.extract_data(response);
        console.log(data);

        this.customers(data.user);
        let new_data = data.user;

        this.setState(
          {
            obj: data,
            user_obj: new_data,
            all_data: new_data,
          },
          () => {
            this.reload_table("transaction", new_data, "user_obj");
          }
        );
      },
      onFinish: () => {
        //this.hide_loading();
      },
    });
  };

  customers = async (data) => {
    UI.set_images(data, "imagePath", "customer", "inquiries", "ecommerce");
  };

  render() {
    const _this = this;
    const {
      // height,
      width,
      // isMobile,
      image,
      item,
      // obj,
      custom_finished_purchases,
      purchasing_customers_id,
      total_inquiries,
      user_obj,
    } = _this.state;

    // **Comment Out, currently unused
    // const { productStats, user } = obj;
    // const { totalFinished, totalPurchase, inquiries } = productStats;

    console.log(this.state.totalPurchaseCustomers);
    return (
      <MainLayout context={context} _this={_this}>
        <View style={styles.main_box_content}>
          <UI.Row breakpoint={1250} style={{ width: "100%" }} _this={_this}>
            <View
              style={{
                ...styles.border_style,
                borderRightWidth: width >= 1250 ? 2 : 0,
                borderBottomWidth: width < 1250 ? 2 : 0,
                paddingRight: width < 1250 ? 0 : 20,
                marginRight: width < 1250 ? 0 : 20,
                paddingBottom: 10,
                marginBottom: width < 1250 ? 10 : 0,
              }}
            >
              <View style={styles.fl_ai}>
                <img
                  style={{ height: 100, width: 100, borderRadius: 5 }}
                  src={image}
                  onError={(e) => {
                    if (e) {
                      this.setState({ image: UI.PRODUCT_BOX });
                    }
                  }}
                  alt="Product"
                />

                {UI.box(width < 980 ? 5 : 10)}

                <View>
                  <Text style={styles.patient_name}>{item.name}</Text>
                  <Text
                    style={{
                      ...styles.patient_name,
                      color: UI.colors.primary,
                      fontSize: 14,
                    }}
                  >
                    Php {item.price}
                  </Text>
                  <Text
                    style={{
                      ...styles.patient_name,
                      color: "#454545",
                      fontSize: 14,
                    }}
                  >
                    Status: {UI.get_active_text(item)}
                  </Text>
                </View>
              </View>
            </View>

            <View style={{ flex: 1 }}>
              <UI.Row _this={_this}>
                <UI.Row breakpoint={970} _this={_this} style={{ flex: 1 }}>
                  <UserDetail
                    icon={UI.PAYMENT_METHOD}
                    name={"Purchase Limit"}
                    value={UI.pad(item.limit ?? 0, 3)}
                  />
                  <UserDetail
                    icon={UI.COMMERCE_INVENTORY}
                    name={"Stock"}
                    value={UI.pad(item.quantity ?? 0, 3)}
                  />
                  <UserDetail
                    icon={UI.DETAILS_AGE}
                    name={"Date Added"}
                    value={UI.get_date_string_by_date(item.createdAt)}
                  />
                </UI.Row>
              </UI.Row>
              {UI.box(10)}
              <Text style={styles.details_name}>Product Description</Text>

              <Text
                style={{
                  ...styles.patient_name,
                  color: "#454545",
                  fontSize: 14,
                }}
              >
                {
                  item.description.split('\r\n').map(a => {
                      return a !== "" && <p>{a} <br></br></p>
                    } 
                  )
                }
              </Text>
            </View>
          </UI.Row>
        </View>

        <UI.Row
          _this={_this}
          breakpoint={1080}
          style={{ width: "100%", flexDirection: "row", marginTop: 20 }}
        >
          <View
            style={{
              ...styles.main_box_content,
              padding: 20,
              flex: 1,
              maxWidth: width > 1080 ? 340 : null,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                width: "100%",
                alignItems: "center",
              }}
            >
              <Text style={styles.box_header_text}>Product Stats</Text>
            </View>

            <ProductStat
              image={UI.IC_DASH_1}
              main={UI.pad(custom_finished_purchases ?? 0, 3)}
              color={UI.colors.primary}
              text={"Finished Product Purchases"}
            />

            <ProductStat
              image={UI.IC_DASH_6}
              main={UI.pad(purchasing_customers_id ?? 0, 3)}
              color={"#00EBBE"}
              text={"Total Purchasing Customers"}
            />

            <ProductStat
              image={UI.IC_DASH_11}
              main={UI.pad(total_inquiries.length ?? 0, 3)}
              color={"#00EB2D"}
              text={"Product Customer Inquiries"}
            />
          </View>

          {UI.box(20)}
          <View
            style={{
              ...styles.main_box_content,
              padding: 0,
              flex: 1,
              alignSelf: width <= 1080 ? "stretch" : "flex-start",
            }}
          >
            <UI.Row
              style={styles.main_container_header}
              breakpoint={1200}
              _this={_this}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
              >
                <Text style={styles.entry_header}>Only Show</Text>
                {UI.box(10)}
                <View>
                  <EntryPicker
                    data_name={"user_obj"}
                    table_name={"transaction"}
                    _this={_this}
                  />
                </View>
              </View>

              <InputForm
                onChange={(e) => {
                  UI.search_table(
                    "transaction",
                    e,
                    this.state.all_data,
                    "user_obj"
                  );
                }}
                _this={_this}
                title={""}
                placeholder={"Enter Keyword"}
                state_name={"search"}
                right={
                  <TouchableOpacity style={styles.search_btn}>
                    <Image
                      height={17}
                      width={17}
                      tintColor={"transparent"}
                      source={UI.SEARCH}
                    />
                  </TouchableOpacity>
                }
                maxLength={UI.Constants.limits.keyword}
                disableLength={true}
              />
            </UI.Row>

            <CustomDatatable
              state_name={"transaction"}
              _this={_this}
              columns={[
                // { ID: "id" },
                { "Customer Name": "customer_name" },
                { Email: "email" },
                { "Contact Number": "contact_number" },
                { "Purchase Date": "purchased_date" },
                { "Purchased With": "purchased_with" },
                { Action: "action" },
              ]}
              data={user_obj.map((item) => {
                let date_added = UI.timestampToDate(
                  new Date(item.createdAt).getTime()
                );

                const email = item.user?.email ?? "-";
                const phone = item.user?.phone ?? "-";

                const customer_image =
                  this.state["customer" + item._id] ?? UI.TRANSACTION_USER;
                return {
                  id: item._id,
                  email: email,
                  contact_number: phone,
                  customer_name: (
                    <View
                      style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <img
                        style={{ height: 35, width: 35 }}
                        src={customer_image}
                        alt="Customer"
                      />
                      <Text style={{ marginLeft: 10 }}>
                        {(item.user?.firstName ?? " ") +
                          " " +
                          (item.user?.lastName ?? " ")}
                      </Text>
                    </View>
                  ),
                  purchased_date:
                    date_added.month +
                    "/" +
                    date_added.day +
                    "/" +
                    date_added.year,
                  purchased_with: item.method,
                  action: (
                    <View style={{ flexDirection: "row" }}>
                      <TouchableOpacity
                        onClick={() => {
                          mem.save("view_transaction", JSON.stringify(item));
                          UI.goTo("/merchant/view-transaction");
                        }}
                      >
                        <Image
                          height={32}
                          width={32}
                          tintColor={"transparent"}
                          source={UI.VIEW_BTN}
                        />
                      </TouchableOpacity>
                    </View>
                  ),
                };
              })}
              on_page={(page, callback, table_name) => {
                UI.on_page(
                  this.state.all_data,
                  callback,
                  table_name,
                  page,
                  "user_obj"
                );
              }}
            />

            <View
              style={{
                ...styles.no_info_container,
                display: user_obj.length > 0 ? "none" : "flex",
              }}
            >
              <UI.Row
                breakpoint={820}
                style={{ maxWidth: 360, alignItems: "center" }}
                _this={_this}
              >
                <Image
                  height={100}
                  width={100}
                  tintColor={"transparent"}
                  source={UI.NO_INFO}
                />
                {UI.box(10)}
                <Text
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    color: "#BFBFBF",
                    textAlign: width > 820 ? "left" : "center",
                    marginLeft: width > 820 ? 20 : 0,
                  }}
                >
                  NO DATA AVAILABLE YET
                </Text>
              </UI.Row>
            </View>
          </View>
        </UI.Row>
      </MainLayout>
    );
  }
}

const ProductStat = (
  props = { image: null, main: "", color: "", text: "" }
) => {
  return (
    <View style={styles.product_stat_item}>
      <Image
        height={70}
        width={70}
        tintColor={"transparent"}
        source={props.image}
      />
      <Text style={{ ...styles.product_stats_text, color: props.color }}>
        {props.main}
      </Text>

      <Text
        style={{
          ...styles.patient_name,
          color: "#535353",
          fontSize: 14,
          textAlign: "right",
          maxWidth: 130,
        }}
      >
        {props.text}
      </Text>
    </View>
  );
};

const UserDetail = (props = { icon: "", name: "", value: "" }) => {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 5,
        flex: 1,
      }}
    >
      <View style={{ ...styles.fl_ai, width: 140 }}>
        <View style={styles.detail_icon}>
          <Image
            height={16}
            width={16}
            tintColor={UI.colors.primary}
            source={props.icon}
          />
        </View>
        <Text style={styles.details_name}>{props.name}</Text>
      </View>
      <Text style={styles.details_value}>{props.value}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  product_stat_item: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 20,
  },
  product_stats_text: {
    color: UI.colors.primary,
    fontWeight: "bold",
    fontSize: 32,
    marginLeft: 15,
    flex: 1,
  },
  detail_icon: {
    height: 16,
    width: 16,
    marginRight: 12,
  },
  details_name: {
    color: UI.colors.primary,
    fontSize: 14,
    fontWeight: "bold",
  },
  details_value: {
    color: "#333333",
    fontSize: 14,
    fontWeight: "bold",
  },
  border_style: {
    borderStyle: "solid",
    borderColor: "#EFEFEF",
  },
  fl_ai: {
    flexDirection: "row",
    alignItems: "center",
  },
  appointment_text: {
    fontSize: 14,
    color: "#333333",
    fontWeight: "bold",
    marginLeft: 10,
  },
  date_container: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 15,
  },
  patient_details: {
    fontSize: 14,
    color: "#898989",
  },
  patient_name: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#535353",
  },
  no_info_container: {
    paddingTop: 50,
    paddingBottom: 50,
    alignItems: "center",
  },
  search_btn: {
    height: 35,
    width: 35,
    justifyContent: "center",
    alignItems: "center",
    marginRight: -5,
  },
  entry_header: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#2E2E2E",
  },
  main_container_header: {
    padding: 10,
    paddingLeft: 20,
    paddingRight: 20,
  },
  main_box_content: {
    borderRadius: 5,
    backgroundColor: "white",
    ...Shadow._3(),
    padding: 20,
  },
  box_header_text: {
    fontSize: 16,
    fontWeight: "bold",
    color: UI.colors.secondary,
    flex: 1,
  },
  header_2: {
    color: "#535353",
    fontSize: 14,
    fontWeight: "bold",
  },
  fade_header: {
    fontWeight: "bold",
    fontSize: 16,
    color: "#B7B7B7",
  },
  main_header: {
    color: UI.colors.primary,
    fontSize: 25,
    fontWeight: "bold",
  },
  header_1: {
    fontSize: 14,
    color: "#535353",
    fontWeight: "bold",
  },
});

// borderRadius: 5, backgroundColor: "white", padding: 10, ...Shadow._3()
